import { footerTheme } from 'themes/jumbo/app/_themes/footer/default';
import { headerTheme } from 'themes/jumbo/app/_themes/header/default';
import { mainTheme } from 'themes/jumbo/app/_themes/main/default';
import { sidebarTheme } from 'themes/jumbo/app/_themes/sidebar/default';
import { footerTheme as footerTheme_light } from 'themes/jumbo/app/_themes/footer/default';
import { headerTheme as headerTheme_light } from 'themes/jumbo/app/_themes/header/default';
import { mainTheme as mainTheme_light } from 'themes/jumbo/app/_themes/main/default';
import { sidebarTheme as sidebarTheme_light } from 'themes/jumbo/app/_themes/sidebar/default';
import { footerTheme as footerTheme_dark } from 'themes/jumbo/app/_themes/footer/dark';
import { headerTheme as headerTheme_dark } from 'themes/jumbo/app/_themes/header/dark';
import { mainTheme as mainTheme_dark } from 'themes/jumbo/app/_themes/main/dark';
import { sidebarTheme as sidebarTheme_dark } from 'themes/jumbo/app/_themes/sidebar/dark';
import { JumboThemeConfig } from 'themes/jumbo/@jumbo/types';
import { createJumboTheme } from 'themes/jumbo/@jumbo/utilities/helpers';

type ConfigType = {
  THEME: JumboThemeConfig;
};

const isLigthTheme = localStorage.getItem('selectedTheme') === 'light';
export const CONFIG: ConfigType = {
  THEME: createJumboTheme(
    isLigthTheme ? mainTheme_light : mainTheme_dark,
    isLigthTheme ? headerTheme_light : headerTheme_dark,
    isLigthTheme ? sidebarTheme_light : sidebarTheme_dark,
    isLigthTheme ? footerTheme_light : footerTheme_dark
  )
};
